/**
 * apps/battle/client/src/terminal/components/AsciiTitle.tsx
 * Static "EconQuest" block-letter banner.
 *
 * Phase 4.2 M4 patch4: redrawn using the patorjk figlet "Big Money-nw" font
 * (rendered via pyfiglet). 9 rows × ~89 cols, drawn with $ / \ / _ / | / /
 * characters so it reads as a stylised banner rather than block-fill.
 *
 * Each backslash in the source ASCII is escaped as \\ in the JS template
 * literal so React renders it correctly.
 */
const BANNER =
  '$$$$$$$$\\                               $$$$$$\\                                  $$\\\n' +
  '$$  _____|                             $$  __$$\\                                 $$ |\n' +
  '$$ |      $$$$$$$\\  $$$$$$\\  $$$$$$$\\  $$ /  $$ |$$\\   $$\\  $$$$$$\\   $$$$$$$\\ $$$$$$\\\n' +
  '$$$$$\\   $$  _____|$$  __$$\\ $$  __$$\\ $$ |  $$ |$$ |  $$ |$$  __$$\\ $$  _____|\\_$$  _|\n' +
  '$$  __|  $$ /      $$ /  $$ |$$ |  $$ |$$ |  $$ |$$ |  $$ |$$$$$$$$ |\\$$$$$$\\    $$ |\n' +
  '$$ |     $$ |      $$ |  $$ |$$ |  $$ |$$ $$\\$$ |$$ |  $$ |$$   ____| \\____$$\\   $$ |$$\\\n' +
  '$$$$$$$$\\\\$$$$$$$\\ \\$$$$$$  |$$ |  $$ |\\$$$$$$ / \\$$$$$$  |\\$$$$$$$\\ $$$$$$$  |  \\$$$$  |\n' +
  '\\________|\\_______| \\______/ \\__|  \\__| \\___$$$\\  \\______/  \\_______|\\_______/    \\____/\n' +
  '                                            \\___|\n';

export function AsciiTitle() {
  return <pre className="tm-ascii-title" aria-label="EconQuest">{BANNER}</pre>;
}
